import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgIf } from "@angular/common";
import { NgbAlert, NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EstadoFiltro } from "@shared/enums/EstadoFiltro";
import { AuthService } from "@authentication/auth.service";
import { UsuarioService } from "@account/usuario.service";
import { NgxSpinnerComponent, NgxSpinnerService } from "ngx-spinner";
import { MessageService } from "@shell/message.service";
import { UsuarioDTO } from "@shared/models/notificaciones";
import { ModalConfirmComponent } from "@shared/generic-modals/modal-confirm.component";
import { ConfiguracionComponenteBloqueo, EstadoSolicitudCliente, SolicitudBloqueoDTO } from "@shared/models/controlCredito/Solicitante";
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { AccionEliminar } from '@shared/enums/AccionEliminar';
import { AprobacionRechazoSolicitudBloqueo, SolicitudAccionBloqueo } from '@shared/models/controlCredito/ConfiguracionBloqueoDTO';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { isEmptyValue } from "@shared/compat-tools";

@Component({
  selector: 'app-reporte-de-bloqueos',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule, FormsModule, NgxSpinnerComponent, NgbTooltip, NgbAlert],
  templateUrl: './reporte-de-bloqueos.component.html',
  styleUrl: './reporte-de-bloqueos.component.scss'
})
export class ReporteDeBloqueosComponent implements OnInit{
  bloquear: boolean = false;
  busquedaFormControl = new FormControl();
  EstadosFiltros :EstadoFiltro[] = Object.values(EstadoFiltro).filter(v => typeof v === 'number') as EstadoFiltro[];
  selecciones = new Map<EstadoFiltro, boolean>();
  stopScroll: boolean;
  ocultarTabla: boolean = false;
  clientesSolicitudes: SolicitudBloqueoDTO[] = [];
  clientesBuscados: SolicitudBloqueoDTO[] = [];
  esAprobador: boolean = false;
  AccionEliminar = AccionEliminar;
  solicitudesSeleccionadas: SolicitudAccionBloqueo[] = [];
  modificando: boolean;
  eliminandoPendiente: boolean[];

  constructor(public authService: AuthService,
              private usuarioService: UsuarioService, private spinner: NgxSpinnerService,
              private messageService: MessageService, private modalService: NgbModal,
              private controlCreditoService: ControlCreditoService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.esAprobador = this.authService.hasRole(TipoUsuario.APROBADORBYR);
    this.busqueda.setValue('');
    this.obtenerSolicitudes();
    this.EstadosFiltros.forEach(estado =>
      this.selecciones.set(estado, false)
    );
  }

  obtenerSolicitudes() {
    this.mostrarSpinner();
    const usuario = this.obtenerUsuario();
    this.solicitudesSeleccionadas = [];
    this.controlCreditoService.obtenerSolicitudesBloqueo(usuario.dni, this.esAprobador).subscribe(c => {
      this.clientesSolicitudes = c;
      this.clientesSolicitudes.forEach(c => {
        if(c.situacionExcedido?.estado !== EstadoSolicitudCliente.Pendiente) c.situacionExcedido = null;
        if(c.situacionVencido?.estado !== EstadoSolicitudCliente.Pendiente) c.situacionVencido = null;
      })
      this.clientesBuscados = [...this.clientesSolicitudes];
      this.eliminandoPendiente = new Array(c.length).fill(false);
      this.ocultarSpinner();
    }, (e: ErrorModel) => {
      this.messageService.showErrorMessage(e.message + e.description);
      this.ocultarSpinner();
    })
  }

  mostrarSpinner(){
    this.ocultarTabla = true;
    this.spinner.show('spinnerLista');
  }

  ocultarSpinner(){
    this.ocultarTabla = false;
    this.spinner.hide('spinnerLista');
  }

  filtrarClientes() {
    this.clientesSolicitudes = this.clientesBuscados.filter(s =>
      s.razonSocial.toLowerCase().includes(this.busqueda.value.toLowerCase())
    );
  }

  obtenerUsuario() : UsuarioDTO {
    const usuario = {
      id: this.usuarioService.getIdUsuario(),
      nombresCompletos: this.usuarioService.getNombresCompletosUsuario(),
      dni: this.usuarioService.getDniUsuario(),
      userName: this.usuarioService.getUsernameByName(),
      email: this.usuarioService.getEmailUsuario()
    }
    return usuario;
  }

  obtenerEtiqueta(estado: EstadoFiltro): string {
    return EstadoFiltro[estado]
      .replace('ExcedidoVencido', 'Excedido y Vencido');
  }

  getDescripcionSituacion(config: ConfiguracionComponenteBloqueo): string {
    switch (config) {
      case ConfiguracionComponenteBloqueo.SinConfiguracion:
        return 'Sin configuración';
      case ConfiguracionComponenteBloqueo.NoBloquear:
        return 'No bloquear';
      case ConfiguracionComponenteBloqueo.NoBloquearDiasInhabiles:
        return 'No bloquear días inhábiles';
      default:
        return '-';
    }
  }
  
  getDescripcionEstado(estado: EstadoSolicitudCliente): string {
    switch (estado) {
      case EstadoSolicitudCliente.Pendiente:
        return 'Pendiente';
      case EstadoSolicitudCliente.Aprobada:
        return 'Aprobada';
      case EstadoSolicitudCliente.Rechazada:
        return 'Rechazada';
      default:
        return '-';
    }
  }

  checkboxSeleccionar(seleccionado: boolean, solicitud: SolicitudBloqueoDTO, esVencido: boolean) {
    const id = solicitud.id;
    const existente = this.solicitudesSeleccionadas.find(s => s.solicitudId === id);
  
    if (seleccionado) {
      if (!existente) {
        this.solicitudesSeleccionadas.push({
          solicitudId: id,
          situacion: esVencido ? AccionEliminar.Vencido : AccionEliminar.Excedido
        });
      } else {
        if (existente.situacion !== AccionEliminar.Ambos) {
          if ((existente.situacion === AccionEliminar.Vencido && !esVencido) ||
              (existente.situacion === AccionEliminar.Excedido && esVencido)) {
            existente.situacion = AccionEliminar.Ambos;
          }
        }
      }
    } else {
      if (!existente) return;

      if (existente.situacion === AccionEliminar.Ambos) {
        existente.situacion = esVencido ? AccionEliminar.Excedido : AccionEliminar.Vencido;
      } else {
        this.solicitudesSeleccionadas = this.solicitudesSeleccionadas.filter(s => s.solicitudId !== id);
      }
    }
    this.cd.detectChanges();
  }

  aprobarRechazarModificaciones(esAprobacion: boolean) {
    const aprobacionRechazoDTO = new AprobacionRechazoSolicitudBloqueo();
    this.modificando = true;
    aprobacionRechazoDTO.usuarioAprobador = this.obtenerUsuario();
    aprobacionRechazoDTO.solicitudesAccion = this.solicitudesSeleccionadas;
    this.controlCreditoService.aprobarRechazarConfiguracionBloqueo(aprobacionRechazoDTO, esAprobacion).subscribe(() => {
      this.messageService.showSuccessMessage(esAprobacion ? 'Los cambios han sido aprobados.' : 'Los cambios han sido rechazados.')
      this.modificando = false;
      this.obtenerSolicitudes();
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage(err.message + err.description);
      this.modificando = false;
    })
  }
  
  
  anularPendiente(i: number, solicitud: SolicitudBloqueoDTO, accion: AccionEliminar) {
    const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.mensaje = '¿Desea eliminar la solicitud pendiente?';
    modalRef.componentInstance.titulo = 'Eliminar Pendiente';
    modalRef.componentInstance.textoSi = 'Aceptar';
    modalRef.componentInstance.textoNo = 'Cancelar';
    modalRef.result.then((result) => {
      if (result === 'Si'){
        this.bloquear = true;
        this.eliminandoPendiente[i] = true;
        this.controlCreditoService.eliminarSolicitudBloqueo(solicitud.id, accion).subscribe(() => {
          this.clientesSolicitudes = this.actualizarClientesSolicitudes(i, accion);
          this.messageService.showSuccessMessage('Eliminado correctamente.');
          this.eliminandoPendiente[i] = false;
          this.bloquear = false;
        })
      }
    }, () => {
      this.bloquear = false;
      this.eliminandoPendiente[i] = false;
    });
  }

  actualizarClientesSolicitudes(i: number, accion: AccionEliminar): SolicitudBloqueoDTO[] {
    const cliente = this.clientesSolicitudes[i];
    if (isEmptyValue(cliente.situacionExcedido) || isEmptyValue(cliente.situacionVencido)) {
      return this.clientesSolicitudes.filter(sol => sol.id !== cliente.id);
    } else {
      return this.clientesSolicitudes.map((cliente, idx) => {
        if (idx === i) {
          return {
            ...cliente,
            situacionExcedido: accion === AccionEliminar.Excedido ? null : cliente.situacionExcedido,
            situacionVencido: accion === AccionEliminar.Vencido ? null : cliente.situacionVencido
          };
        }
        return cliente;
      });
    }
  }

  get busqueda() {
    return this.busquedaFormControl;
  }

  get haySelecciones(): boolean {
    return this.solicitudesSeleccionadas.length > 0;
  }
}
